module.exports = __webpack_public_path__ + "img/12-full-md.b645a14b.jpg";